import React, { useEffect, useState } from "react";
import styles from "./css/MyAccount.module.css";
import { TextField } from "@mui/material";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import {
  setFirstName,
  setLastName,
  setEmail,
} from "../../redux/slices/userSlice";
import { store } from "../../redux/store";

const MyAccount = () => {
  const dispatch = useDispatch();
  const language = useSelector((state: any) => state.language.value);
  const userInfo = useSelector((state: any) => state.user);

  // State for form fields
  const [firstName, setFirstNameState] = useState(userInfo.firstName);
  const [lastName, setLastNameState] = useState(userInfo.lastName);
  const [email, setEmailState] = useState(userInfo.email);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const accessToken = localStorage.getItem("accessToken");

  const handleMe = async (accessToken: any) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_SERVER_URL}/auth/profile`,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      // Update Redux store with profile data
      dispatch(setFirstName(response.data.firstName || ""));
      dispatch(setLastName(response.data.lastName || ""));
      dispatch(setEmail(response.data.email || ""));

      // Update local state
      setFirstNameState(response.data.firstName || "");
      setLastNameState(response.data.lastName || "");
      setEmailState(response.data.email || "");

      console.log("Me info:", response.data);
    } catch (err) {
      console.error(
        language === "RO"
          ? "Eroare la încărcarea profilului:"
          : "Error loading profile:",
        err
      );
    }
  };

  const handleUpdate = async () => {
    setLoading(true);
    setMessage("");

    try {
      const response = await axios.put(
        `${process.env.REACT_APP_SERVER_URL}/auth/update-info`,
        { firstName, lastName, email },
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
        }
      );

      // Update Redux store after successful update
      dispatch(setFirstName(firstName));
      dispatch(setLastName(lastName));
      dispatch(setEmail(email));

      // Log the current Redux state
      console.log("Redux State after update:", {
        firstName: firstName,
        lastName: lastName,
        email: email,
      });

      // Get the entire Redux state
      const currentState = store.getState();
      console.log("Complete Redux State:", currentState);

      setMessage(
        language === "RO"
          ? "Profilul a fost actualizat cu succes!"
          : "Profile updated successfully!"
      );
      console.log("Update response:", response.data);
    } catch (error: any) {
      // Check specifically for email already in use error
      if (error.response?.data?.message === "Email is already in use") {
        setMessage(
          language === "RO"
            ? "Această adresă de email este deja folosită."
            : "This email address is already in use."
        );
      } else {
        setMessage(
          language === "RO"
            ? error.response?.data?.message || "A apărut o eroare."
            : error.response?.data?.message || "An error occurred."
        );
      }
      console.error(
        language === "RO"
          ? "Eroare la actualizarea profilului:"
          : "Error updating profile:",
        error
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    handleMe(accessToken);
  }, [language]);

  // Update local state when Redux store changes
  useEffect(() => {
    setFirstNameState(userInfo.firstName);
    setLastNameState(userInfo.lastName);
    setEmailState(userInfo.email);
  }, [userInfo]);

  return (
    <div className={styles.productContainer}>
      <span className={styles.productTitle}>
        {language === "RO" ? "Contul meu" : "My account"}
      </span>
      <div className={styles.productInfo}>
        <div className={styles.frame}>
          <span className={styles.productTitle7}>
            {language === "RO" ? "Date personale" : "Personal data"}
          </span>
          <div className={styles.form}>
            <div className={styles.inputs}>
              <div className={styles.inputField}>
                <TextField
                  value={firstName}
                  onChange={(e) => {
                    setFirstNameState(e.target.value);
                  }}
                  sx={{
                    width: "100%",
                    height: "inherit",
                    "& .MuiFilledInput-root": {
                      height: "inherit",
                    },
                    input: { color: "#517059" },
                    "& .MuiInputBase-input::placeholder": {
                      color: "#517059",
                      opacity: 1,
                    },
                  }}
                  hiddenLabel
                  id="first-name"
                  placeholder={language === "RO" ? "Prenume *" : "First name *"}
                  variant="filled"
                />
              </div>
            </div>
            <div className={styles.inputField9}>
              <div className={styles.inputFieldA}>
                <TextField
                  value={lastName}
                  onChange={(e) => {
                    setLastNameState(e.target.value);
                  }}
                  sx={{
                    width: "100%",
                    height: "inherit",
                    "& .MuiFilledInput-root": {
                      height: "inherit",
                    },
                    input: { color: "#517059" },
                    "& .MuiInputBase-input::placeholder": {
                      color: "#517059",
                      opacity: 1,
                    },
                  }}
                  hiddenLabel
                  id="last-name"
                  placeholder={language === "RO" ? "Nume *" : "Last name *"}
                  variant="filled"
                />
              </div>
            </div>
            <div className={styles.inputFieldC}>
              <div className={styles.inputsD}>
                <TextField
                  value={email}
                  onChange={(e) => {
                    setEmailState(e.target.value);
                  }}
                  sx={{
                    width: "100%",
                    height: "inherit",
                    "& .MuiFilledInput-root": {
                      height: "inherit",
                    },
                    input: { color: "#517059" },
                    "& .MuiInputBase-input::placeholder": {
                      color: "#517059",
                      opacity: 1,
                    },
                  }}
                  hiddenLabel
                  id="email"
                  placeholder={language === "RO" ? "E-mail *" : "E-mail *"}
                  variant="filled"
                />
              </div>
            </div>
          </div>

          {/* Display success/error message */}
          {message && <p className={styles.message}>{message}</p>}

          <button
            className={styles.buttonE}
            onClick={handleUpdate}
            disabled={loading}
          >
            <span className={styles.addToCartF}>
              {loading
                ? language === "RO"
                  ? "Se actualizează..."
                  : "Updating..."
                : language === "RO"
                ? "Actualizează"
                : "Update"}
            </span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default MyAccount;
